/**
 * `/api/customer-communication/v1`
 */
export function makeCustomerCommunicationV1URL(uri: `/${string}`): URL {
  return new URL(`/api/customer-communication/v1${uri}`, window.configs.API_HOST);
}

export function makeCustomerCommunicationV2URL(uri: `/${string}`): URL {
  return new URL(`/api/customer-communication/v2${uri}`, window.configs.API_HOST);
}
